export default $axios => ({
    getMainSlider() {
        return $axios({
            method: 'GET',
            url: '/base/slides_banner'
        });
    },
    getProductSliders() {
        return $axios({
            method: 'GET',
            url: '/general/sliders'
        });
    },
    getCategories() {
        return $axios({
            method: 'GET',
            url: '/general/menu_tree'
        });
    },
    getTopCategories() {
        return $axios({
            method: 'GET',
            url: '/base/main_page_similar_category'
        });
    },
    postBookConsultation(data) {
        return $axios({
            method: 'POST',
            url: `/base/book-consultation`, // have UTM data
            data: data
        });
    },
    getPopularQuestions() {
        return $axios({
            method: 'GET',
            url: '/base/faq'
        });
    },
    getServices() {
        return $axios({
            method: 'GET',
            url: '/base/services/'
        });
    },
    postSubscribeToNewsletter(data) {
        return $axios({
            method: 'POST',
            url: `/settings/news-letter/`,
            data: data
        });
    },
    postLeaveRequest(data) {
        return $axios({
            method: 'POST',
            url: `/base/user-request/`,
            data: data
        });
    },
    getPartners() {
        return $axios({
            method: 'GET',
            url: '/general/brand/'
        });
    }
});
